import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
    import { DateTime } from "luxon";
    import { Size } from '../../components/basic_button/size';
    import { store } from '../../store';
    import { ACUMATICA_INSTANCE_URL, ACUMATICA_CLIENT_ID, ACUMATICA_REDIRECT_URI, ACUMATICA_SCOPE } from '../../module/common/env';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'status',
  setup(__props, { expose: __expose }) {
  __expose();

    const pinia_store = store()

    const com_is_acumatica_authed = computed(() => {
        return pinia_store.is_acumatica_authed
    })
    const com_projects_sync_attempted_at = computed(() => {
        return format_date(pinia_store.projects_sync_attempted_at)
    })
    const com_projects_sync_succeeded_at = computed(() => {
        return format_date(pinia_store.projects_sync_succeeded_at)
    })
    const com_purchase_orders_sync_attempted_at = computed(() => {
        return format_date(pinia_store.purchase_orders_sync_attempted_at)
    })
    const com_purchase_orders_sync_succeeded_at = computed(() => {
        return format_date(pinia_store.purchase_orders_sync_succeeded_at)
    })

    const format_date = function (arg_date_string: string) {
        if (arg_date_string === "") {
            return ""
        }        

        const loc_date = DateTime.fromISO(arg_date_string).setZone("America/Chicago");

        return loc_date.toFormat("MMMM dd h:mma");
    }

    async function start_acumatica_auth() {
        const loc_query_params = new URLSearchParams({
            response_type: "code",
            client_id: ACUMATICA_CLIENT_ID,
            redirect_uri: ACUMATICA_REDIRECT_URI,
            scope: ACUMATICA_SCOPE
        }).toString();

        console.log("Start acumatica auth", ACUMATICA_INSTANCE_URL + "/identity/connect/authorize?" + loc_query_params)
        window.open(ACUMATICA_INSTANCE_URL + "/identity/connect/authorize?" + loc_query_params, '_blank');
    }

const __returned__ = { pinia_store, com_is_acumatica_authed, com_projects_sync_attempted_at, com_projects_sync_succeeded_at, com_purchase_orders_sync_attempted_at, com_purchase_orders_sync_succeeded_at, format_date, start_acumatica_auth, get Size() { return Size } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})